import React from 'react';
import { Flex, objectArraySort, Avatar } from '@mss/mss-component-library';
import TimeAgo from 'react-timeago';
import { TFunction } from 'i18next';

const columns = (t: TFunction) => [
  {
    title: '',
    dataIndex: 'first_name',
    key: 'first_name',
    width: 30,
    render: (a: any, record: any) => (
      <Flex h="center" v="center">
        <Avatar firstName={record.first_name} lastName={record.last_name} />
      </Flex>
    ),
  },
  {
    title: t('User'),
    dataIndex: 'first_name',
    key: 'name',
    render: (a: any, record: any) => `${record.first_name} ${record.last_name}`,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'first_name'),
  },
  {
    title: t('Email address'),
    dataIndex: 'email',
    key: 'email',
    width: 250,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'email'),
  },
  {
    title: t('Status'),
    dataIndex: 'is_active',
    key: 'is_active',
    width: 100,
    render: (active: boolean) => (active ? 'Active' : 'Inactive'),
  },
  {
    title: t('Last login'),
    dataIndex: 'last_login',
    key: 'last_login',
    width: 180,
    sorter: (a: any, b: any) => objectArraySort(a, b, 'last_login_sortfix'),
    // sorter: function(a, b) {
    //   if (a.last_login != null || a > b) return -1;
    //   if (b.last_login != null || b > a) return 1;
    //   return 0;
    // },
    render: (last_login: string | null) =>
      last_login ? <TimeAgo date={last_login} /> : 'Never',
  },
];

export default columns;
